export const alwaysActiveFieldsForPM = [
  'verifyRequest',
  'submittedCancelDiscoDate',
  'disconnectCompletionDate',
  'cancellationCompletionDate',
  'disconnectTrackingNumber',
];

export const includedFields = ['product'];
